export const RAPTOR_SAMPLE_RATE = 1 // raptor采样率
export const HOME_POP_LOGAN = {
  NO_DATA: 'no_data',
  DATA_LENGTH_EMPTY: 'data_length_empty',
  CHECK_NO_PASS: 'check_no_pass',
  FFS_HOME_EFFECT_START: 'ffs_home_effect_start',
  FFS_HOME_EFFECT_FAILED: 'ffs_home_effect_failed',
}
export const RESOURCE_ERROR_BOUNDARY = 'RESOURCE_ERROR_BOUNDARY'
export const MKT_RESOURCE_SHOW = 'MKT_RESOURCE_SHOW'
